import { TournamentPhase } from '.';

export function isPreReady(phase: TournamentPhase) {
  return phase === 'checkIn' || phase === 'registration' || phase === 'live';
}
